import { useHistory } from 'react-router-dom'
import { makeStyles, Grid, Typography, Box, Button } from '@material-ui/core'

import { useAuth } from 'hooks'

import styles from './styles'

const useStyles = makeStyles(styles)

const NotFound = () => {
  const classes = useStyles()
  const history = useHistory()
  const auth = useAuth()

  return (
    <Box className={classes.root}>
      <Grid container justifyContent="center" spacing={4}>
        <Grid item lg={6} xs={12}>
          <Box className={classes.content}>
            <Typography variant="h1">404: Página não encontrada</Typography>
            <Typography variant="subtitle2">
              Você tentou algum caminho desconhecido ou veio aqui por engano.
              Seja qual for, tente usar a navegação
            </Typography>
            <Box mt={3}>
              <Button
                color="primary"
                variant="contained"
                onClick={() => history.push(auth.homePage)}
              >
                Voltar ao início
              </Button>
            </Box>
            <img
              alt="Em desenvolvimento"
              className={classes.image}
              src="/images/404.svg"
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default NotFound
